'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WidgetBodyDiv = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  height: calc(100% - ', 'px);\n'], ['\n  display: flex;\n  flex-direction: column;\n  height: calc(100% - ', 'px);\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _immutable = require('immutable');

var _ChatHeadingConfigPropType = require('ui-addon-conversations/chat-heading-config/prop-types/ChatHeadingConfigPropType');

var _ChatHeadingConfigPropType2 = _interopRequireDefault(_ChatHeadingConfigPropType);

var _RecordPropType = require('conversations-prop-types/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

var _WidgetLocations = require('../constants/WidgetLocations');

var _WidgetHeader = require('./WidgetHeader');

var _WidgetHeader2 = _interopRequireDefault(_WidgetHeader);

var _VisitorWidgetStyleWrapper = require('../../presentation-components/VisitorWidgetStyleWrapper');

var _VisitorWidgetStyleWrapper2 = _interopRequireDefault(_VisitorWidgetStyleWrapper);

var _dimensions = require('ui-addon-conversations/widget-dimensions/constants/dimensions');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var WidgetBodyDiv = exports.WidgetBodyDiv = _styledComponents2.default.div.withConfig({
  displayName: 'VisitorWidget__WidgetBodyDiv'
})(_templateObject, _dimensions.HEADER_HEIGHT);

var VisitorWidget = function (_Component) {
  _inherits(VisitorWidget, _Component);

  function VisitorWidget() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, VisitorWidget);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = VisitorWidget.__proto__ || Object.getPrototypeOf(VisitorWidget)).call.apply(_ref, [this].concat(args))), _this), _this.closeWidget = function () {
      _this.props.onUpdateOpened(false);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(VisitorWidget, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          browserWindowHeight = _props.browserWindowHeight,
          chatHeadingConfig = _props.chatHeadingConfig,
          currentConversation = _props.currentConversation,
          chatHeadingResponders = _props.chatHeadingResponders,
          coloring = _props.coloring,
          inline = _props.inline,
          isPreview = _props.isPreview,
          isOpen = _props.isOpen,
          isThreadAssigned = _props.isThreadAssigned,
          createNewThread = _props.createNewThread,
          mobile = _props.mobile,
          officeHoursMessage = _props.officeHoursMessage,
          showAvailabilityMessage = _props.showAvailabilityMessage,
          showThreadList = _props.showThreadList,
          showThreadListButton = _props.showThreadListButton,
          showingHsBranding = _props.showingHsBranding,
          size = _props.size,
          style = _props.style,
          typicalResponseTimeMessage = _props.typicalResponseTimeMessage,
          unseenThreadsCountExcludingCurrentThread = _props.unseenThreadsCountExcludingCurrentThread,
          viewingThreadList = _props.viewingThreadList,
          widgetLocation = _props.widgetLocation;


      if (!isOpen) {
        return null;
      }

      return _react2.default.createElement(
        _VisitorWidgetStyleWrapper2.default,
        {
          browserWindowHeight: browserWindowHeight,
          inline: inline,
          isOpen: isOpen,
          size: size,
          style: style,
          mobile: mobile,
          widgetLocation: widgetLocation
        },
        _react2.default.createElement(_WidgetHeader2.default, {
          chatHeadingConfig: chatHeadingConfig,
          coloring: coloring,
          createNewThread: createNewThread,
          currentConversation: currentConversation,
          chatHeadingResponders: chatHeadingResponders,
          inline: inline,
          isThreadAssigned: isThreadAssigned,
          mobile: mobile,
          officeHoursMessage: officeHoursMessage,
          onClose: this.closeWidget,
          preview: isPreview,
          showAvailabilityMessage: showAvailabilityMessage,
          showThreadList: showThreadList,
          showThreadListButton: showThreadListButton,
          showingHsBranding: showingHsBranding,
          typicalResponseTimeMessage: typicalResponseTimeMessage,
          unseenThreadsCountExcludingCurrentThread: unseenThreadsCountExcludingCurrentThread,
          viewingThreadList: viewingThreadList
        }),
        _react2.default.createElement(
          WidgetBodyDiv,
          null,
          this.props.children
        )
      );
    }
  }]);

  return VisitorWidget;
}(_react.Component);

VisitorWidget.propTypes = {
  browserWindowHeight: _react.PropTypes.number.isRequired,
  chatHeadingConfig: _ChatHeadingConfigPropType2.default.isRequired,
  chatHeadingResponders: _react.PropTypes.instanceOf(_immutable.List),
  children: _react.PropTypes.node.isRequired,
  coloring: (0, _RecordPropType2.default)('ColoringRecord').isRequired,
  createNewThread: _react.PropTypes.func,
  currentConversation: (0, _RecordPropType2.default)('Conversation'),
  inline: _react.PropTypes.bool.isRequired,
  isOpen: _react.PropTypes.bool.isRequired,
  isPreview: _react.PropTypes.bool.isRequired,
  isThreadAssigned: _react.PropTypes.bool.isRequired,
  mobile: _react.PropTypes.bool.isRequired,
  officeHoursMessage: _react.PropTypes.string,
  onUpdateOpened: _react.PropTypes.func,
  showAvailabilityMessage: _react.PropTypes.bool,
  showThreadList: _react.PropTypes.func,
  showThreadListButton: _react.PropTypes.bool.isRequired,
  showingHsBranding: _react.PropTypes.bool,
  size: _react.PropTypes.string,
  style: _react.PropTypes.object,
  typicalResponseTimeMessage: _react.PropTypes.string,
  unseenThreadsCountExcludingCurrentThread: _react.PropTypes.number,
  viewingThreadList: _react.PropTypes.bool,
  widgetLocation: _WidgetLocations.WidgetLocationProp
};

VisitorWidget.defaultProps = {
  inline: false,
  isOpen: false,
  isPreview: false,
  isThreadAssigned: false,
  mobile: false,
  onUpdateOpened: function onUpdateOpened() {},
  widgetLocation: _WidgetLocations.RIGHT_ALIGNED
};

exports.default = VisitorWidget;